export default 'https://arb1.arbitrum.io/rpc'